import { cartLinkStyles } from "@insite/content-library/Widgets/Common/CartLink";
import { css } from "styled-components";

cartLinkStyles.routerLink = {
    typographyProps: {
        variant: "headerSecondary",
    },
    icon: {
        iconProps: {
            size: 24,
            color: "#007bff",
            css: css`
                text-decoration: none;
                background-color: transparent;
                display: flex;
                justify-content: center;
                align-items: center;
                width: 2.5rem;
                height: 2.5rem;
                padding-right: 0;
                margin-right: 3px;
                &:hover {
                    background-color: #2060ad;
                    border-radius: 50%;
                    color: #ffffff !important;
                    width: 2.5rem;
                    height: 2.5rem;
                    text-align: center;
                }
                &:focus {
                    background-color: #002554;
                }
            `,
        },
    },
    color: "#007bff",
    css: css`
        height: 3.125rem;
        padding: 0 .250625rem 0 .625rem;
        &:focus {
            outline-style: none !important;
        }
        &:focus-visible {
            outline: 2px dashed #2060ad !important;
        }
        @media (max-width: 767px) {
            margin-left: .625rem;
        }
        span > span {
            font-size: 0;
            > span {
                background-color: #002554;
                padding: .125rem;
                border-radius: 100%;
                top: -.9375rem;
                position: relative;
                right: .75rem;
                color: #ffb600;
                font-family: 'Roboto', sans-serif;
                font-size: .8125rem;
                font-weight: bold;
                line-height: .875rem;
                display: inline-block;
                height: 1.1875rem;
                width: 1.1875rem;
                text-align: center;
                padding-top: 0.188rem;
                padding-bottom: 0.125rem;
                &:after {
                    content: '';
                    display: inline-block;
                }
            }
        }
    `,
};
